export default __webpack_public_path__ + "static/media/monkey-1.7f81ea77.png";